import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { CurrentWsState } from './types';

const initState = () => {
    return new  CurrentWsState();
};

export const useCurrentWsStore = createStoreModule<CurrentWsState, IAction<CurrentWsState>>(initState, 'root-currentWs');
